import React from 'react'
import Modal, { ModalFooter } from '../../components/Modal'
import { ConfirmAssetAmount, ConfirmAssetLabel, ConfirmAssetMeta, ConfirmAssetRow, ConfirmNote, ConfirmSummary } from './style'
import { roundAssetAmount } from '../../util/Util'
import FeeValues from './FeeValues'
import { PrimaryButton, SecondaryButton } from '../../components/Button'
interface ConfirmModalProps {
  isConfirmOpen: boolean
  setIsConfirmOpen: (value: boolean) => void
  isConfirming: boolean
  handleConfirmSwap: () => void
  fromLogo: string
  fromTicker: string
  fromInputValue: number | null
  toLogo: string
  toTicker: string
  toInputValue: number | null
  exchangeRate: number
  fee: number | null
}

const ConfirmModal = ({
  isConfirmOpen,
  setIsConfirmOpen,
  isConfirming,
  handleConfirmSwap,
  fromLogo,
  fromTicker,
  fromInputValue,
  toLogo,
  toTicker,
  toInputValue,
  exchangeRate,
  fee
}: ConfirmModalProps): JSX.Element => {
  return (
    <Modal
      visible={isConfirmOpen}
      onClose={() => setIsConfirmOpen(false)}
      innerStyles={{ width: 420 }}
      title="Confirm conversion"
    >
      <ConfirmSummary>
        <ConfirmAssetRow>
          <ConfirmAssetMeta>
            <ConfirmAssetLabel>You pay</ConfirmAssetLabel>
            <ConfirmAssetAmount>
              <img src={fromLogo} alt={`${fromTicker} Logo`} />
              {roundAssetAmount(fromTicker, fromInputValue ?? 0)} {fromTicker}
            </ConfirmAssetAmount>
          </ConfirmAssetMeta>
          <ConfirmAssetMeta>
            <ConfirmAssetLabel>You receive</ConfirmAssetLabel>
            <ConfirmAssetAmount>
              <img src={toLogo} alt={`${toTicker} Logo`} />
              {roundAssetAmount(toTicker, toInputValue ?? 0)} {toTicker}
            </ConfirmAssetAmount>
          </ConfirmAssetMeta>
        </ConfirmAssetRow>
      </ConfirmSummary>

      <FeeValues
        isLoading={false}
        exchangeRate={`1 ${fromTicker} = ${roundAssetAmount(toTicker, exchangeRate ?? 0)} ${toTicker}`}
        fee={`${roundAssetAmount(fromTicker, fee ?? 0)} ${fromTicker}`}
      />

      <ConfirmNote>
            Estimated rates can move before execution. The final quote is locked only when you confirm the conversion.
      </ConfirmNote>

      <ModalFooter $fullWidthAction>
        <SecondaryButton style={{ flex: 1 }}
          disabled={isConfirming} onClick={() => setIsConfirmOpen(false)}>Back</SecondaryButton>
        <PrimaryButton style={{ flex: 1 }} isLoading={isConfirming} onClick={handleConfirmSwap}>Confirm</PrimaryButton>
      </ModalFooter>
    </Modal>
  )
}

export default ConfirmModal